<template>
  <v-container fluid>
    <canvas class="canvas_matrix_rain" ref="canv" width="0" height="0" @click="offMatrixEffect"></canvas>
    <!-- Селекторы -->
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <v-card>
          <v-card-title>
            Матрица
            <v-spacer></v-spacer>
            <span @click="matrixEffect" class="m_eff"></span>
          </v-card-title>

          <v-form ref="form">
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="6" md="4" lg="4">
                  <group-selector noRules v-model="groups" @change:users="fillAgents" />
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="4">
                  <user-selector v-model="agents" />
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="4">
                  <project-selector v-model="projects" />
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="4">
                  <custom-select
                    label="Смены"
                    v-model="shifts"
                    :items="shiftForSelectorClean"
                    multiple
                  ></custom-select>
                </v-col>

                <v-col cols="12" sm="6" md="1" lg="1">
                  <v-checkbox
                    v-model="operators_only"
                    hide-details
                    label="Операторы"
                  ></v-checkbox>
                </v-col>


                <v-col cols="12" sm="6" md="7" lg="7" align="right">
                  <v-btn
                    color="success"
                    id="rep_btn"
                    @click="loadReport"
                    style="margin-top: 13px"
                  >
                    Поиск
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>



    <!-- Модалка изменение скила -->
    <div class="modal_wrap" @click="closeModal($event)" :class="[skillLevelBlock.isOpen ? 'd-flex' : 'd-none']">
      <v-card>
        <div class="modal_block" >
          <div class="modal_header">
            <h3 style="margin-bottom: 1.6rem;">Изменить уровень скила </h3>
            <span class="modal_close" @click="closeModal">x</span>
          </div>
          <p style="margin:0;">ФИО: {{ skillLevelBlock.name }} </p>
          <p>Проект: {{ skillLevelBlock.project }} </p>
          <ul class="skill_list">
            <li
              v-for="(opt, index) in skillLevelForSelector" :key="`li-${index}`"
              class="skill_list_item"
              :class="skillLevelBlock.skillLvl == opt.id ? 'active' : ''"
              :data-value="opt.id"
              @click="saveSkillLevel(opt.id)"
            >
              {{ opt.name }}
            </li>
          </ul>
        </div>
      </v-card>
    </div>

    <!-- Модалка изменение комментов -->
    <div class="modal_wrap" @click="closeModal2($event)" :class="[commentsBlock.isOpen ? 'd-flex' : 'd-none']">
      <v-card>
        <div class="modal_block">
          <div class="modal_header">
            <h3 style="margin-bottom: 1.6rem;">Изменить коммент</h3>
            <span class="modal_close" @click="closeModal2">x</span>
          </div>
          <p style="margin-bottom: 3rem;">ФИО: {{ commentsBlock.name }} </p>
          <label>Комментарий: <input
            type="text"
            :class="[isDarkTheme ? 'dark' : '', 'comment_input']"
            style="margin-bottom: 3rem;"
            :value="commentsBlock.comment"
            @change="changeComment($event)"
          ></label>
          <label v-if="hasRole('leader')"> <v-icon dense>mdi-shield-account-outline</v-icon> Комментарий для руководителей: <input
            type="text"
            :class="[isDarkTheme ? 'dark' : '', 'comment_input']"
            :value="commentsBlock.commentForLeader"
            @change="changeCommentForLeader($event)"
          ></label>
          <div class="modal_save_btn">
            <v-btn color="success" @click="saveComment">Сохранить</v-btn>
          </div>
        </div>
      </v-card>
    </div>

    <!-- Модалка изменение смен -->
    <div class="modal_wrap" @click="closeModal3($event)" :class="[shiftBlock.isOpen ? 'd-flex' : 'd-none']">
      <v-card>
        <div class="modal_block">
          <div class="modal_header">
            <h3 style="margin-bottom: 1.6rem;">Изменить смену</h3>
            <span class="modal_close" @click="closeModal3">x</span>
          </div>
          <p style="margin-bottom: 3rem;">ФИО: {{ shiftBlock.name }} </p>
          <ul class="skill_list">
            <li
              v-for="(opt, index) in shiftForSelector" :key="`li-shift-${index}`"
              class="skill_list_item"
              :class="shiftBlock.id == opt.id ? 'active' : ''"
              :data-value="opt.id"
              @click="saveShift(opt.id)"
            >
              {{ opt.name }}
            </li>
          </ul>
        </div>
      </v-card>
    </div>




    <v-card class="mt-5">
      <div class="tables_container" v-if="reportLoaded">
        <!-- Таблица с именами -->
        <div>
          <div
            class="fio_header"
            :class="[isDarkTheme ? 'dark_theme_active': 'light_theme_active']"
            @click.prevent="sortReportByName"
          >ФИО <v-icon small>mdi-sort</v-icon> </div>
          <div class="fio_table_column" ref="fioColumn">
            <table>
              <tr v-for="(item, index) in report" :key="`fio_table_key_tr_${index}`">
                <td> {{ item.fullname }} </td>
              </tr>
            </table>
          </div>
        </div>

        <div class="matrix_table_container" @scroll="syncScroll($event)">
          <table class="matrix_report_table">
            <!-- ЗАГОЛОВКИ ТАБЛИЦЫ -->
              <thead>
                <tr style="height: 130px;">
                  <th :class="[isDarkTheme ? 'dark_theme_active': 'light_theme_active']" style="max-width:400px;">Коммент</th>

                  <th
                    class="groups_th"
                    :class="[isDarkTheme ? 'dark_theme_active': 'light_theme_active']"
                    @click.prevent="sortReportByGroup"
                  >Группы<v-icon x-small>mdi-sort</v-icon></th>

                  <th
                    class="shift_th"
                    :class="[isDarkTheme ? 'dark_theme_active': 'light_theme_active']"
                    style="min-width: 110px;"
                    @click.prevent="sortReportByShift"
                  >Смены<v-icon x-small>mdi-sort</v-icon></th>

                  <th :class="[isDarkTheme ? 'dark_theme_active': 'light_theme_active']">Кол-во проектов</th>

                  <th
                    v-for="(pId, index) in projectsOneTime"
                    class="project_th"
                    :class="[isDarkTheme ? 'dark_theme_active': 'light_theme_active']"
                    @click.prevent="sortReportByProject(pId)"
                    :key="`matrix_project_th_${index+5}`"
                  >
                    <!-- <span class="skill_sum">({{ knownCount(pId) }})</span>{{ projectsGetter.find(el => el.id == pId).name }}<v-icon x-small>mdi-sort</v-icon> -->
                    <div class="project_name" :title="projectsGetter.find(el => el.id == pId).name">
                      <span class="project_name_title">{{ projectsGetter.find(el => el.id == pId).name }}</span>
                      <span class="skill_sum">{{ knownCount(pId) }}</span>
                      <!-- <v-icon x-small>mdi-sort</v-icon> -->
                    </div>
                  </th>

                </tr>
              </thead>

            <!-- ТЕЛО ТАБЛИЦЫ -->
              <tbody>
                <tr v-for="(item, index) in report" :key="`matrix_table_tr11_${index + 5}`">

                  <td
                    v-if="hasPermission('statiz.edit-matrix-comment')"
                    @click="openCommentEdit(item)"
                    class="action_column overflow_collapse"
                    :title="(item.comment || item.comment_for_leader) ? `${item.comment} | ${item.comment_for_leader}` : ''"
                    style="max-width:400px;"
                  >
                    {{ item.comment }}
                    <v-icon v-if="item.comment_for_leader" title="коммент для руков" dense>mdi-shield-account-outline</v-icon>
                    {{ item.comment_for_leader }}
                  </td>
                  <td
                    v-else
                    class="overflow_collapse"
                    :title="item.comment || ''"
                    style="max-width:400px;"
                  >
                    {{ item.comment }}
                  </td>

                  <td :title="item.groups.map(el => el.name).join(', ')" class="overflow_collapse"> {{ filterGroups(item.groups) }} </td>

                  <td
                    v-if="hasPermission('statiz.edit-matrix-shift')"
                    @click.prevent="openShiftEdit(item)"
                    class="action_column overflow_collapse"
                  > {{ item.shift ? item.shift.name : '' }} </td>
                  <td
                    v-else
                    class="overflow_collapse"
                  > {{ item.shift ? item.shift.name : '' }} </td>

                  <td> {{ item.knowns_the_projects_count }} </td>

                  <td v-for="(projId, index) in projectsOneTime" :key="`matrix_td_projects_${index + 2}`">
                    <div
                      v-if="hasPermission('statiz.edit-matrix-skills')"
                      class="project_selector"
                      :class="getBgColor(item.projects[projId].skill_level_id)"
                      @click="openSelector(item, projId)"
                      :title="getProjectTitle(item.projects[projId].skill_level_id)"
                    >
                      <span v-if="getBgColor(item.projects[projId].skill_level_id) === 'success'" style="color: black">+</span>
                    </div>
                    <div
                      v-else
                      class="project_selector no_permision"
                      :class="getBgColor(item.projects[projId].skill_level_id)"
                      :title="getProjectTitle(item.projects[projId].skill_level_id)"
                    >
                      <span v-if="getBgColor(item.projects[projId].skill_level_id) === 'success'" style="color: black">+</span>
                    </div>
                  </td>
                </tr>
              </tbody>
          </table>
        </div>
      </div>

    </v-card>

  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ProjectSelector from '~/components/partials/selectors/ProjectSelector.vue';
import UserSelector from '~/components/partials/selectors/UserSelector.vue';
import GroupSelector from '~/components/partials/selectors/GroupSelector.vue';
import { axios } from "~/plugins/axios";

export default {
  components: { UserSelector, ProjectSelector, GroupSelector },
  name: "OperatorsMatrix",

  data() {
    return {
      groups: [],
      agents: [],
      projects: [],
      projectsOneTime: [],
      skillLevelForSelector: [],
      shiftForSelector: [],
      operators_only: false,
      skillLevelBlock: {
        isOpen: false,
        name: null,
        project: null,
        userId: null,
        projectId: null,
        skillLvl: 1,
      },
      commentsBlock: {
        isOpen: false,
        name: null,
        userId: null,
        comment: null,
        commentForLeader: null,
      },
      shiftBlock: {
        isOpen: false,
        id: '',
        name: null,
        userId: null,
      },
      payload: {
        projects: [],
        operators: [],
      },
      shifts: [],

      reportLoaded: false,
    };
  },

  computed: {
    ...mapGetters({
      hasRole: 'user/hasRole',
      hasPermission: 'user/hasPermission',
      // agentsGetter: 'projects/agents',
      projectsGetter: 'graphql/allProjects',
      groupsGetter: 'projects/groups',
      report: 'operators/report',
    }),

    isDarkTheme() {
      return this.$vuetify.theme.isDark;
    },

    shiftForSelectorClean() {
      return this.shiftForSelector.slice(1)
    },

  },

  watch: {},

  methods: {
    ...mapActions({
      setLoading: 'shared/setLoading',
      loadProjects: 'graphql/loadAllProjects',
      loadGroups: 'projects/loadGroups',
      loadMatrixReport: 'operators/loadMatrixReport',
      resetAllState: 'resetAllState',
    }),

    syncScroll(ev) {
      let scrollTop = ev.target.scrollTop;
      this.$refs.fioColumn.style.marginTop = 130 - scrollTop + 'px';
    },

    closeModal(ev) {
      if (ev.target.classList.contains('modal_wrap') || ev.target.classList.contains('modal_close')) this.skillLevelBlock.isOpen = false;
    },
    closeModal2(ev) {
      if (ev.target.classList.contains('modal_wrap') || ev.target.classList.contains('modal_close')) this.commentsBlock.isOpen = false;
    },
    closeModal3(ev) {
      if (ev.target.classList.contains('modal_wrap') || ev.target.classList.contains('modal_close')) this.shiftBlock.isOpen = false;
    },

    openSelector(item, projId) {
      this.skillLevelBlock.name = item.fullname;
      this.skillLevelBlock.project = this.projectsGetter.find(el => el.id == projId).name;
      this.skillLevelBlock.userId = item.user_id;
      this.skillLevelBlock.projectId = projId;
      this.skillLevelBlock.skillLvl = item.projects[projId].skill_level_id;

      this.skillLevelBlock.isOpen = true;
    },

    openCommentEdit(item) {
      this.commentsBlock.userId = item.user_id;
      this.commentsBlock.name = item.fullname;
      this.commentsBlock.comment = item.comment;
      this.commentsBlock.commentForLeader = item.comment_for_leader;

      this.commentsBlock.isOpen = true;
    },

    openShiftEdit(item) {
      this.shiftBlock.name = item.fullname;
      this.shiftBlock.userId = item.user_id;
      this.shiftBlock.id = item.shift ? item.shift.id : '';

      this.shiftBlock.isOpen = true;
    },

    changeComment(event) {
      this.commentsBlock.comment = event.target.value;
    },

    changeCommentForLeader(event) {
      this.commentsBlock.commentForLeader = event.target.value;
    },

    // getRandomKey(num) {
    //   return Math.random() * num + Date.now() - Math.random();
    // },

    getBgColor(skillLevelId) {
      let clr = this.skillLevelForSelector.find(el => el.id == skillLevelId);
      return clr ? clr.cell_color : this.skillLevelForSelector[0].cell_color;
    },

    getProjectTitle(skillLvl) {
      return this.skillLevelForSelector.find(el => el.id == skillLvl).name;
    },

    filterGroups(groups) {
      let res = groups.map(el => el.name);
      if (res.length > 3) return res.slice(0, 3).join(', ') + ` ещё групп ${groups.length - 3}... `;
      return res.join(', ');
    },

    saveComment() {
      let payload = null;
      if (!this.hasRole('leader')) payload = {comment: this.commentsBlock.comment};
      else payload = {
        comment: this.commentsBlock.comment,
        comment_for_leader: this.commentsBlock.commentForLeader
      };

      axios.post(`/api/users/${this.commentsBlock.userId}/changeMatrixComment`, payload)
        .then(() => {
          let usr = this.report.find(el => el.user_id == this.commentsBlock.userId)
          usr.comment = this.commentsBlock.comment;
          usr.comment_for_leader = this.commentsBlock.commentForLeader;
        })
        .catch((err) => this.$store.commit("shared/SET_ERROR", err.response.data, {
            root: true,
        }));

      this.commentsBlock.isOpen = false;
    },

    async saveSkillLevel(skillLvl) {
      this.skillLevelBlock.skillLvl = skillLvl;

      await axios.post(`/api/users/${this.skillLevelBlock.userId}/changeProjectSkillLevel`, {
          project_id: this.skillLevelBlock.projectId,
          skill_level_id: skillLvl,
        })
        .then((resp) => {
          this.$store.commit("shared/SET_SUCCESS", {
            message: resp.data.message,
          });
          this.report.find(el => el.user_id == this.skillLevelBlock.userId)
            .projects[this.skillLevelBlock.projectId].skill_level_id = skillLvl;
        })
        .catch((err) => this.$store.commit("shared/SET_ERROR", err.response.data, {
            root: true,
        }));

      this.skillLevelBlock.isOpen = false;
    },

    async saveShift(shiftId) {
      this.shiftBlock.id = shiftId;

      if (shiftId === '') {
        await axios.post(`/api/users/${this.shiftBlock.userId}/changeShift`, {shift_id: shiftId})
          .then((resp) => {
          this.$store.commit("shared/SET_SUCCESS", {
            message: resp.data.message,
          });
          this.report.find(el => el.user_id == this.shiftBlock.userId)
              .shift = null;
        })
        .catch((err) => this.$store.commit("shared/SET_ERROR", err.response.data, {
            root: true,
        }));
      } else {
        await axios.post(`/api/users/${this.shiftBlock.userId}/changeShift`, {shift_id: shiftId})
          .then((resp) => {
            this.$store.commit("shared/SET_SUCCESS", {
              message: resp.data.message,
            });
            let shift = this.shiftForSelector.find(el => el.id === shiftId);
            this.report.find(el => el.user_id == this.shiftBlock.userId)
              .shift = shift;
          })
          .catch((err) => this.$store.commit("shared/SET_ERROR", err.response.data, {
              root: true,
          }));
      }

      this.shiftBlock.isOpen = false;
    },

    fillAgents(operators) {
      this.agents = operators;
    },

    knownCount(projectId) {
      return this.report.reduce((count, el) => {
        return el.projects[projectId].skill_level_id == 1 ? ++count : count;
      }, 0);
    },

    sortReportByName() {
      this.report.sort((prev, curr) => {
        if (prev.fullname > curr.fullname) return 1;
        if (prev.fullname < curr.fullname) return -1;
        if (prev.fullname == curr.fullname) return 0;
      });
    },

    sortReportByProject(projectId) {
      this.report.sort((prev, curr) => {
        let prevSkill = prev.projects[projectId].skill_level_id;
        let currSkill = curr.projects[projectId].skill_level_id;

        let tmpPrev = (prevSkill === '') ? Number.MAX_SAFE_INTEGER : prevSkill;
        let tmpCurr = (currSkill === '') ? Number.MAX_SAFE_INTEGER : currSkill;

        if (tmpPrev > tmpCurr) return 1;
        if (tmpPrev < tmpCurr) return -1;
        if (tmpPrev == tmpCurr) return 0;
      });
    },

    sortReportByGroup() {
      this.report.sort((prev, curr) => {
        let tmpPrev = prev.groups.map(el => el.name).join(',');
        let tmpCurr = curr.groups.map(el => el.name).join(',');

        if (tmpPrev > tmpCurr) return 1;
        if (tmpPrev < tmpCurr) return -1;
        if (tmpPrev == tmpCurr) return 0;
      });
    },

    sortReportByShift() {
      this.report.sort((prev, curr) => {
        let prevShift = prev.shift ? prev.shift.id : Number.MAX_SAFE_INTEGER;
        let currShift = curr.shift ? curr.shift.id : Number.MAX_SAFE_INTEGER;

        if (prevShift > currShift) return 1;
        if (prevShift < currShift) return -1;
        if (prevShift == currShift) return 0;
      });
    },



    async loadReport() {
      if (!this.$refs.form.validate()) return
      this.reportLoaded = false;

      this.$store.commit('shared/SET_LOADING', true, {root: true});
      this.$store.commit('operators/SET_REPORT', []);

      this.payload.operators = this.agents;
      this.payload.projects = this.projects;
      this.payload.operators_only = this.operators_only;
      if (this.operators_only) this.payload.operators_only = true;
      else delete this.payload.operators_only;

      // this.payload.operators = [275,419,1771,3945,4439,4767,7889];


      this.projectsOneTime = this.projects.slice();
      if (this.shifts.length > 0) this.payload.shifts = this.shifts;
      else if (this.payload.shifts) delete this.payload.shifts;

      await this.loadMatrixReport(this.payload);

      await this.report.forEach(item => {
        this.projectsOneTime.forEach(pId => {
          if (!(pId in item.projects)) item.projects[pId] = {skill_level_id: ''};
        })
      })

      this.sortReportByName();

      this.$store.commit('shared/SET_LOADING', false, {root: true});
      this.reportLoaded = true;
    },




    // matrixRain =D "I am the ONE"
    matrixEffect() {
      // Initialising the canvas
      let canvas = this.$refs.canv;
      let ctx = canvas.getContext('2d');

      // Setting the width and height of the canvas
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;

      // Setting up the letters
      let letters = 'ABCDEFGHIJKLMNOPQRSTUVXYZABCDEFGHIJKLMNOPQRSTUVXYZABCDEFGHIJKLMNOPQRSTUVXYZABCDEFGHIJKLMNOPQRSTUVXYZABCDEFGHIJKLMNOPQRSTUVXYZABCDEFGHIJKLMNOPQRSTUVXYZ';
      letters = letters.split('');

      // Setting up the columns
      let fontSize = 10,
          columns = canvas.width / fontSize;

      // Setting up the drops
      let drops = [];
      for (let i = 0; i < columns; i++) {
        drops[i] = 1;
      }

      // Setting up the draw function
      function draw() {
        ctx.fillStyle = 'rgba(0, 0, 0, .1)';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        for (let i = 0; i < drops.length; i++) {
          let text = letters[Math.floor(Math.random() * letters.length)];
          ctx.fillStyle = '#0f0';
          ctx.fillText(text, i * fontSize, drops[i] * fontSize);
          drops[i]++;
          if (drops[i] * fontSize > canvas.height && Math.random() > .95) {
            drops[i] = 0;
          }
        }
      }

      // Loop the animation
      canvas.dataset.interval = setInterval(draw, 60);
    },

    offMatrixEffect() {
      if (this.$refs.canv.hasAttribute('data-interval')) {
        let int = this.$refs.canv.dataset.interval;
        clearInterval(int);
        this.$refs.canv.width = 0;
        this.$refs.canv.height = 0;
      }
    },
  },

  async mounted() {
    this.setLoading(false, {root: true});
    await this.loadProjects();

    this.skillLevelForSelector.push({
      id: '',
      name:"Не выбрано",
      cell_color: 'grey lighten-2',
    });
    let forSel = await axios.get("/api/skillLevels").then(resp => resp.data.data);
    this.skillLevelForSelector.push(...forSel);

    this.shiftForSelector.push({
      id: '',
      code: "shift_0",
      name: "Не выбрано",
      color: "#a6a6a6"
    });
    let forShiftSel = await axios.get("/api/shifts").then(resp => resp.data);
    this.shiftForSelector.push(...forShiftSel);
    this.setLoading(false, {root: true});
  },

  beforeDestroy() {
    this.$store.commit('operators/SET_REPORT', []);
    this.resetAllState();
  }
};
</script>

<style scoped lang="scss">

.project_selector {
	border-radius: 2px;
	color: transparent;
	// user-select: none;
	cursor: pointer;

  width: 25px;
  aspect-ratio: 1;
  text-align: center;
  font-weight: bold;

	&:hover {
		filter: contrast(0.5);
	}
  &.no_permision{
    cursor: initial;
  }
}
.modal_wrap {
	display: flex;
	justify-content: center;
	align-items: center;
	position: fixed;
	top: 0;
	left: 0;
	width: calc(100vw - 1px);
	height: calc(100vh - 1px);
	background-color: rgba(0, 0, 0, 0.36);
	z-index: 99;
}
.modal_block {
	width: 400px;
	padding: 1rem;
}
.modal_save_btn {
	text-align: right;
	margin-top: 2rem;
}
.skill_list {
	list-style: none;
	line-height: 1.7;
	padding: 0.5rem 0 !important;
}
.modal_header {
	display: flex;
	justify-content: space-between;
}
.modal_close {
	cursor: pointer;
	font-size: 1.8rem;
	margin-top: -13px;
	user-select: none;
}
.comment_input {
	display: block;
	margin-block: 1rem;
	border-bottom: 1px solid #444;
	width: 90%;
	&:focus {
		outline: none;
	}
	&.dark {
		color: #fff;
	}
}
.skill_list_item {
	padding-left: 1rem;
	padding-right: 1rem;
	cursor: pointer;
	&:hover {
		background-color: #a1a1a18c;
	}
	&.active {
		background-color: #28a745a3;
	}
}
.matrix_table_container {
	overflow-x: auto;
	max-height: calc(100vh - 64px);

	scrollbar-width: thin;
	scrollbar-color: green transparent;
}
.tables_container {
	display: flex;
	max-height: calc(100vh - 65px);
	min-height: 120px;
	overflow: hidden;
}
.fio_header {
	width: 250px;
	height: 114px;
	position: absolute;
	z-index: 2;
	text-align: center;
	line-height: 80px;
	font-weight: bold;

  cursor: pointer;
}
.fio_header:hover,
.groups_th:hover,
.shift_th:hover {
  text-decoration: underline;
  text-underline-offset: 0.5em;
}
.fio_table_column {
	margin-top: 130px;
	border-right: 2px solid hsla(0, 0%, 50%, 0.161);
	table {
		width: 250px;
		border-collapse: collapse;
	}
	tr {
		height: 30px;
		border-bottom: 1px solid hsla(0, 0%, 50.2%, 0.42);
	}
	td {
		padding-left: 1rem;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
}
.matrix_report_table {
	position: relative;
	border-collapse: collapse;
	th {
		position: sticky;
		top: -16px;
	}
	tr {
		height: 30px;
		border-bottom: 1px solid hsla(0, 0%, 50.2%, 0.42);
		&:hover {
			background-color: #a1a1a136;
		}
	}
  th, td {
    padding: 0.1rem 0.2rem;
  }
  th:nth-child(1),
  td:nth-child(1),
  th:nth-child(2),
  td:nth-child(2),
  th:nth-child(3),
  td:nth-child(3) {
    padding: 0.1rem 1rem;
  }

  .skill_sum {
    font-size: 0.7em;
  }
}
.groups_th {
	max-width: 250px;
}
.groups_th,
.shift_th {
  cursor: pointer;
}

.project_th {
  cursor: pointer;

  .project_name {
    $width: 25px;

    width: $width;
    height: 70px;

    &_title {
      display: block;
      width: 100%;
      height: 80%;
      font-size: 0.8rem;
      font-weight: normal;
      line-height: $width;
      writing-mode: vertical-rl;
      text-align: start;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      transform: rotate(180deg);
    }
  }

  &:hover {
    .project_name_title {
      color: #549362;
    }
  }
}

.overflow_collapse {
	max-width: 250px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.action_column {
	cursor: pointer;
	&:hover {
		background-color: #a1a1a136;
	}
}
.canvas_matrix_rain {
	position: fixed;
	left: 0;
	top: 0;
	z-index: 9;
	opacity: 0.5;
}
.m_eff {
	display: block;
	width: 10px;
	height: 10px;
	cursor: pointer;
}
.dark_theme_active {
	background-color: #1e1e1e;
}
.light_theme_active {
	background-color: #fff;
}

</style>